<template>
	<v-container>
		<v-row
			v-if="false"
			align="center"
			justify="space-around"
		>
			<v-btn>
				<v-icon>
					mdi-cloud-upload
				</v-icon>
				Operacion
			</v-btn>
			<v-btn color="primary">
				<v-icon>
					mdi-cloud-upload
				</v-icon>
				Limites
			</v-btn>
		</v-row>
		<v-alert
			v-if="false"
			dense
			outlined
			type="error"
		>
			No se encuentran <strong>datos</strong> para el dia <strong> {{viewDate | dateFormat}} </strong>
		</v-alert>
		<v-row>
			<v-col
				cols="12"
				sm="6"
			>
				<v-select
					v-model="selectProject"
					:items="projectTest"
					item-value="_id"
					item-text="name"
					label="Projectos"
					outlined
				>
				</v-select>
			</v-col>
			<v-col
				cols="12"
				sm="6"
			>
				<v-btn
					style="margin-top: 15px;"
					depressed
					color="primary"
					@click="getDevicesData"
				>
					Cargar
				</v-btn>
			</v-col>
			<v-col cols="12" v-show="isLoading">
				<v-skeleton-loader
					type="image"
				></v-skeleton-loader>
				<v-skeleton-loader
					type="image"
				></v-skeleton-loader>
			</v-col>
			<v-col cols="12" v-show="!isLoading">
				<apexchart ref="chart" height="400px" :options="options" :series="series"></apexchart>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import moment from 'moment'
	import VueApexCharts from 'vue-apexcharts'
	import axios from 'axios'
	import authHeader from '../../services/authHeader';
	import settings from '@/constants/settings.js'

	export default {
		name: 'Compare',

		data: () => ({
            options: {
				colors: ['#E53935','#1E88E5', '#5c54a4', '#87ceff', '#1E88E5', '#5c54a4', '#87ceff', '#86BBF9', '#2EC1D5', '#67D148', '#A82332', '#CCF658'],
				markers: {
					showNullDataPoints: false,
				},
				stroke: {
					width: [2, 2, 2, 2, 2],
					curve: 'straight'
				},
				chart: {
					type: 'line',
					id: 'hA',
					group: 'social',
				},
				yaxis: {
					labels: {
						minWidth: 0,
						formatter: function (value) {
							return value.toFixed(1) + ""
						}
					},
					title: {
						text: 'Decibeles [dBA]',
					},
				},
				annotations: {
					xaxis: [],
					points: []
				},
				xaxis: {
					type: 'datetime',
					tickAmount: 1,
					labels: {
						show: true,
						datetimeUTC: false,
						format: 'HH:mm:ss',
					}
				},
				tooltip: {
					x: {
						format: "HH:mm:ss"
					}
				},
            },
			series: [],
			Laeqfs: [],
			selectProject: null
        }),
		
		methods: {
			async getDevicesData () {
				const url = `${settings.URL_API}/projecttest/report/${this.selectProject}?date=${this.viewDate}`
				const response = await axios.get(url, { headers: authHeader() })
				this.dataCharts(response.data.data)
			},

			dataCharts (data) {
				
				this.options.annotations.xaxis = []
				this.options.annotations.points = []
				
				this.$refs.chart.updateOptions({
					annotations: {
						points: [],
						xaxis: []
					}
				})

				this.series = []

				for (let j = 0; j < data.length; j++) {
					let Laeqfs = []
					// const devicesInfo = this.findDeviceInfo(data[j].deviceId)

					// const laeqSensor = devicesInfo.sensors.find( e => {
					// 	return e.sensorType === 'laeq'
					// }).sensorName
	
					let offsetloco = 0
					// let offsetloco = this.laeqOffset (data[j].deviceId, laeqSensor)
					const info = data[j].info

					if (info.length === 0)
						continue

					for (let i = 0; i < info.length; i++) {
						const laqeValue = info[i].report.avg + offsetloco
						let laqeValuePre = laqeValue

						if (i > 0)
							laqeValuePre = info[i - 1].report.avg + offsetloco
						
						let laeqSensorValue
						let laeqFilter

						// if (!Object.hasOwnProperty.call(devicesInfo, "laeqFilter")) {
							laeqFilter = {
								max: 100,
								min: 0
							}
						// } else {
						// 	laeqFilter = devicesInfo.laeqFilter
						// }

						if (laqeValue > laeqFilter.max || laqeValue < laeqFilter.min)
							laeqSensorValue = null
						else 
							laeqSensorValue = laqeValue

						Laeqfs.push({
							str: info[i].ts,
							x: new Date(info[i].ts).getTime(),
							y: laeqSensorValue
						})
					}

					// this.series.push({
					// 	type: 'line',
					// 	name: `Nivel sonoro equivalente asdasd`,
					// 	data: Laeqfs
					// })
					this.series.push({
						type: 'line',
						name: `Nivel sonoro equivalente ${data[j].sensorName}`,
						data: Laeqfs
					})
				}

				this.$store.dispatch('handleLoading', false)
			},

			laeqOffset (deviceId, sensorName) {
				const findSensor = this.allSensors.filter( sensor => sensor.deviceId === deviceId && sensor.sensorName === sensorName )

				if (findSensor.length > 0)
					return findSensor[0].offset

				return 0
			},

			findDeviceInfo (deviceId) {
				return this.$store.getters.device(deviceId)
			},
		},

		computed: {
			viewDate () {
				return this.$store.getters.viewDate
			},

			isLoading () {
				return this.$store.getters.isLoading
			},

			devices () {
				return this.$store.getters.devices
			},

			dayReport () {
                return moment(this.devicesDateCompare.date).format("YYYY-MM-DD") 
			},

			devicesDateCompare () {
                return this.$store.getters.devicesDateCompare
			},

			allSensors () {
				return this.$store.getters.allSensors
			},

			projectTest() {
				return this.$store.getters.projectTest
			},
		},

		watch: {
			devicesDateCompare (val) {
				this.dataCharts(val)
			},

			selectProject (val) {
				this.$store.dispatch('setViewProjectTest', val)
			}
		},

		filters : {
			dateFormat (val) {
				if (!moment(val).isValid())
					return val

				return moment(val).format('LL')
			},
		},

		components: {
			apexchart: VueApexCharts
		},

		created () {
			this.$store.dispatch('pullProjectTest')
			moment.locale('es-us')
		}
	}
</script>
